import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  accordion: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
  accordionSummary: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  accordionDetails: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));
